var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.legend && _vm.legend.length > 0)?_c('div',{staticClass:"legend-view smooth-shadow"},[_c('LegendBar',{attrs:{"legend":_vm.legend,"enableFilter":true},on:{"applyFilter":_vm.setFilter}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }